<template>
  <form-group class="text-input" :label="label" :errors="internalErrors" @focus="focus">
    <input ref="primaryInput" class="uk-input" :class="inputCss" :value="internalValue" :type="type"
      :placeholder="placeholder" :disabled="disabled" :autocomplete="autocomplete" :maxlength="maxLength" :step="step"
      :min="min" :max="max" @input="onInput" @focus="$emit('focus')" @blur="$emit('blur')">
  </form-group>
</template>

<script>
import Input from '@/mixins/Input';

export default {
  name: 'text-input',
  mixins: [Input],
  props: {
    value: null,
    placeholder: String,
    type: {
      type: String,
      default: 'text',
    },
    autocomplete: String,
    maxLength: {
      type: Number,
      default: 255,
    },
    step: null,
    min: Number,
    max: Number,
  },
  methods: {
    onInput(event) {
      let value = event.target.value;
      if (this.type === 'number') {
        value = parseFloat(value);
      }
      this.$emit('input', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// TextInput.vue?e11501b2